export default __webpack_public_path__ + "static/media/HallsofEternalFrost.1b6bb57d.jpg";